import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { listResource, createResource, updateResource, deleteResource, formatApiErrorDetail } from "@/lib/api";

export function useResourceList(resource, params = {}) {
  return useQuery({
    queryKey: [resource, params],
    queryFn: () => listResource(resource, params),
  });
}

export function useResourceMutations(resource, opts = {}) {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: [resource] });
    qc.invalidateQueries({ queryKey: ["dashboard"] });
    qc.invalidateQueries({ queryKey: ["nav-counters"] });
  };

  const create = useMutation({
    mutationFn: (body) => {
      if (body && body.__headers) {
        const { __headers, ...rest } = body;
        return createResource(resource, rest, __headers);
      }
      return createResource(resource, body);
    },
    onSuccess: () => { invalidate(); toast.success(opts.createMsg || "Created successfully"); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  const update = useMutation({
    mutationFn: ({ id, body }) => updateResource(resource, id, body),
    onSuccess: () => { invalidate(); toast.success(opts.updateMsg || "Saved successfully"); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  const remove = useMutation({
    mutationFn: (arg) => {
      const id = arg && typeof arg === "object" ? arg.id : arg;
      const params = arg && typeof arg === "object" ? arg.params : undefined;
      return deleteResource(resource, id, params);
    },
    onSuccess: () => { invalidate(); toast.success("Deleted"); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });

  return { create, update, remove };
}
